/* @flow */

import clsx from 'clsx';
import { useCallback } from 'react';
import * as React from 'react';

import './ButtonLink.css';

type PropType = {
  +'aria-label'?: string,
  +children: React.Node,
  +className?: string,
  +data?: any,
  +isDisabled?: boolean,
  +onClick: (event: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement>, data: any) => Promise<void> | void,
};

const ButtonLink = (buttonLinkProps: PropType): React.Node => {
  const { 'aria-label': ariaLabel, children, className, data, isDisabled = false, onClick } = buttonLinkProps;

  const handleOnClick = useCallback(
    (event: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement>) => {
      if (isDisabled) {
        return;
      }

      onClick(event, data);
    },
    [data, isDisabled, onClick],
  );

  return (
    <button aria-label={ariaLabel} className={clsx('linkButton', isDisabled && 'disabled', className)} disabled={isDisabled} onClick={handleOnClick} type='button'>
      {children}
    </button>
  );
};

export default ButtonLink;
